

export const url = 'https://dev.codicepay.com/PaymentPlanetAPI/api/';
//export const url = 'http://qa.codicepay.com/PaymentPlanetAPI/api/';
//export const url = 'https://codicepay.com/PaymentPlanetAPI/api/';


